module.exports = __webpack_public_path__ + "img/session6_logo1.ab2d1882.png";